export default () => {
  return (
    <svg
      width="11"
      height="15"
      viewBox="0 0 13 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 0C0.89543 0 0 0.89543 0 2V7.9C0 9.00457 0.89543 9.9 2 9.9H2.9C3.45229 9.9 3.9 10.3477 3.9 10.9V15.2612C3.9 16.1938 5.06381 16.6188 5.66473 15.9056L11.6145 8.84435C12.1624 8.19404 11.7001 7.2 10.8498 7.2H9.75576C8.93999 7.2 8.46745 6.27584 8.94508 5.61451L11.8549 1.58549C12.3325 0.924164 11.86 0 11.0442 0H2Z"
        fill="currentColor"
      />
    </svg>
  )
};
